
import Vue from 'vue';
import { Icon } from '@descomplica/vue-components';
import { ListItemModel } from '@descomplica/dex-models';
import CircleProgressBar from './progress/CircleProgressBar.vue';

export default Vue.extend({
  components: {
    Icon,
    CircleProgressBar,
  },
  props: {
    actived: {
      type: Boolean,
      default: false,
    },
    listItem: {
      type: Object as Vue.PropType<ListItemModel>,
      required: true,
    },
  },
  computed: {
    isCompleted(): boolean {
      return this.listItem.isCompleted();
    },
    lessonProgress(): number {
      return this.actived && this.listItem.progress === 0 ? 100 : this.listItem.progress;
    },
  },
});
